export default "__VITE_ASSET__D80_gJ8l__"